/* export function PhoneRegex(phoneNumber) {
    const phoneRegex = /^\+(?:[0-9] ?){6,14}[0-9]$/;
    const nonZeroRegex = /^[1-9]\d*$/;

    const parts = phoneNumber.split(" ");
    parts.shift();
    const number = parts.join('');

    // Vérifier si le nombre après l'indicatif est supérieur à 8
    return !(!phoneRegex.test() && (!nonZeroRegex.test(number) || number.length < 8));
} */
import {matchIsValidTel} from "mui-tel-input";

export function PhoneRegex(phoneNumber) {

    return matchIsValidTel(phoneNumber);
}
